import React, {useEffect, useState} from "react";

import {epdAstralService, companyService, systemService} from "../../../../services";
import {Alert, Select, Table} from "antd";
import {Button, Col, Form, Icon, Input, Modal, notification, Row, Steps, Upload} from "antd";
import InputField from "../../../input-field";
import FieldBlock from "../../../field-block";
import SelectField from "../../../select-field";
import DividerBlock from "../../../divider-block";
import Spinner from "../../../spinner";
import ModalRegisterApiAttorney from "../register-api-attorney";
import i18n from "../../../../i18n";


export default function ModalAttorneyApiCompany({
                                               legalEntityId,
                                               legalEntityName,
                                               isShow,
                                               onCloseModal,
                                               setIsNeedUpdate,
                                             }) {
  const {Option} = Select;
  const [fieldsErrors, setFieldsErrors] = useState(null);
  const [message, setMessage] = useState('');

  const [personsList, setPersonsList] = useState([]);
  const [personId, setPersonId] = useState(null);
  const [personName, setPersonName] = useState('');
  const [showRegisterAttorney, setShowRegisterAttorney] = useState(false);

  let bigButtonStyle = {
    width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px'
  };

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined") ? fieldsErrors[nameField][0] : null;
  };


  useEffect(() => {
    if (isShow) {
      epdAstralService
        .getCompanyPersonsWithAttorney({legalEntityId: legalEntityId})
        .then(resp => {
          setPersonsList(resp);
        })
        .catch(err => {
          notification.error({
            message: i18n.t('components.notification.titles.getCompanyPersonsWithAttorney'),
            description: err
          });
        });
    }
  }, [isShow]);

  let modalTitle = i18n.t('modals.modalAttorneyApiCompany.title');

    const columns = [
    {
      title: i18n.t('modals.modalAttorneyApiCompany.table.firstName.title'),
      width: '35%',
      key: 'FirstName',
      //dataIndex: "FirstName",
      render: record => (
        <React.Fragment>
          {record.FirstName} {record.Patronymic} {record.SecondName}
        </React.Fragment>
      )
    },
    {
      title: i18n.t('modals.modalAttorneyApiCompany.table.attorney.title'),
      width: '35%',
      key: 'Attorney',
      render: record => {
        if(record.Attorney) {
          return (
            <>
              {record.Attorney.Date} {record.Attorney.Number}
            </>
          );
        } else {
          return (
            <>{i18n.t('modals.modalAttorneyApiCompany.table.attorney.noData')}</>
          )
        }
      }
    },
    {
      title: i18n.t('modals.modalAttorneyApiCompany.table.actions.title'),
      width: '30%',
      key: 'actions',
      render: record => (
          <React.Fragment>
            <Button
              type="primary"
              icon="plus"
              style={{width: '100%'}}
              key={`${record.Id}-plus`}
              onClick={() => {
                  setPersonId(record.Id);
                  setPersonName(record.FirstName + ' ' + record.Patronymic + ' ' + record.SecondName);
                  setShowRegisterAttorney(true);
                }
              }
            >
              {i18n.t('modals.modalAttorneyApiCompany.buttons.upload')}
            </Button>
          </React.Fragment>
      )
    }
  ]

  return (<Modal
      title={<div>{modalTitle}</div>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        onCloseModal(null);
      }}
      forceRender={true}
      footer={<div></div>}
    >
      <>
        <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
          <Col span={24}>
            <h2>{i18n.t('modals.modalAttorneyApiCompany.fields.legalEntityName.title')}: {legalEntityName}</h2>
          </Col>
        </Row>
        <Spinner loading={!personsList} label={i18n.t('modals.modalAttorneyApiCompany.loading')}>
          <Table
            style={{ minWidth: "700px" }}
            columns={columns}
            dataSource={personsList.Employees}
            locale={{ emptyText: i18n.t('modals.modalAttorneyApiCompany.table.emptyText') }}
            size="small"
            pagination={{
              pageSize: 50,
            }}
            rowKey={(record, index) => ('employee-'+index)}
            rowClassName={(record, index) => ("employee-row")}
          />
        </Spinner>
        <ModalRegisterApiAttorney
          legalEntityName={legalEntityName}
          legalEntityId={legalEntityId}
          personId={personId}
          personName={personName}
          isShow={showRegisterAttorney}
          onCloseModal={setShowRegisterAttorney}
          setIsNeedUpdate={setIsNeedUpdate}
        />
      </>
    </Modal>
  )
}
